export default __webpack_public_path__ + "static/media/registered.9bbce1ba.svg";